export default "__VITE_ASSET__BsrDrCbk__"